// extracted by mini-css-extract-plugin
export default {"PrintedBomIFrameWrapper":"printedBom-module_PrintedBomIFrameWrapper_2WtvL","PrintedBomIFrame":"printedBom-module_PrintedBomIFrame_3bNA4"};